module.exports = __webpack_public_path__ + "img/stock2.79d762db.png";